import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Box, Text, useTheme, Heading, Flex, VStack } from "@chakra-ui/react";
import Lottie from "components/Lottie";
import CheckmarkAnimation from "assets/animations/checkmark.json";

/**
 * Component for rendering success screen, and triggering unmount if provided.
 * @param {Object} props - Component props.
 * @param {Function} props.message - Success message to display. I needs to be pre-internationalized.
 * @param {Function} props.onUnmount - Callback function to trigger after unmounting.
 * @returns {JSX.Element} - Success screen component JSX.
 */
const SuccessScreen = ({ message, onUnmount }) => {
  const theme = useTheme();
  const animationColors = [
    theme.colors.integrator[500],
    theme.colors.white,
    theme.colors.integrator[500],
    theme.colors.white,
    theme.colors.integrator[500],
  ];

  useEffect(() => {
    let onSuccessTimeout = null;
    // This will trigger onUnmount function after 3 seconds
    // it is onUnmount responsibility to not render this component
    // see Iban form example
    onSuccessTimeout = setTimeout(() => {
      onUnmount && onUnmount();
    }, 3000);

    return () => {
      clearTimeout(onSuccessTimeout);
    };
  }, [onUnmount]);
  return (
    <VStack spacing="4" px="4" pb="6" py="10">
      <Box textAlign="center">
        <Heading mb="2">
          <FormattedMessage defaultMessage="Success" description="label" />
        </Heading>
        <Text fontSize="sm" color="secondaryText">
          {message}
        </Text>
      </Box>

      <Flex alignItems="center" justifyContent="center">
        <Lottie
          animation={CheckmarkAnimation}
          width={300}
          height={300}
          colors={animationColors}
          loop={false}
          additionalDivProps={{
            "data-testid": "lottie-checkmark-animation",
          }}
        />
      </Flex>
    </VStack>
  );
};

export default SuccessScreen;
